import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';

const markdownComponents: any = {
    p: ({ node, ...props }: any) => <p style={{ margin: '0 0 0 0' }} {...props} />,
    ul: ({ node, ...props }: any) => <ul style={{ margin: '0 0 10px 0', paddingLeft: '20px' }} {...props} />,
    ol: ({ node, ...props }: any) => <ol style={{ margin: '0 0 10px 0', paddingLeft: '20px' }} {...props} />,
    a: ({ node, ...props }: any) => (
        <a target="_blank" rel="noopener noreferrer" {...props} />
    ),
    pre: ({ node, ...props }: any) => (
        <pre style={{
            backgroundColor: '#2b2b2b', color: '#f8f8f2', padding: '10px',
            borderRadius: '5px', overflowX: 'auto', fontFamily: 'monospace', margin: '10px 0'
        }} {...props} />
    ),
    code: ({ node, className, ...props }: any) => {
        const isInline = !className?.includes('language-');
        return (
            <code style={{
                fontFamily: 'monospace',
                backgroundColor: isInline ? 'rgba(128,128,128,0.2)' : 'transparent',
                padding: isInline ? '2px 4px' : '0',
                borderRadius: isInline ? '3px' : '0'
            }} className={className} {...props} />
        );
    },
    table: ({ node, ...props }: any) => (
        <div style={{ width: '100%', overflowX: 'auto', margin: '10px 0' }}>
            <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: '100%' }} {...props} />
        </div>
    ),
    th: ({ node, style, ...props }: any) => (
        <th style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left', backgroundColor: '#d0d0d0', color: '#131417', ...style }} {...props} />
    ),
    td: ({ node, style, ...props }: any) => (
        <td style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left', ...style }} {...props} />
    ),
    img: ({ node, ...props }: any) => (
        <img style={{ maxWidth: '100%', borderRadius: '4px', marginTop: '8px' }} {...props} />
    ),
    video: ({ node, ...props }: any) => (
        <video style={{ maxWidth: '100%', borderRadius: '4px', marginTop: '8px' }} controls {...props} />
    )
};

export function MarkdownMessage(props: { children: string | null | undefined }) {
    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm, remarkBreaks]}
            components={markdownComponents}
        >
            {props.children}
        </ReactMarkdown>
    );
}
